export default __webpack_public_path__ + "static/media/crown.7a6490ac.svg";